import { Text as T } from '@eo-locale/preact';
import clsx from 'clsx';

import { useModal } from 'components/ModalProvider';
import { useSettings } from 'components/SettingsProvider';

import { ReviewsModal } from './components/ReviewsModal';

import styles from './ReviewsTabWidget.module.scss';

export function ReviewsTabWidget() {
  const { open, openModal } = useModal();
  const {
    utils: { isRtl },
  } = useSettings();

  return (
    <>
      {open && <ReviewsModal />}
      <div
        className={clsx(styles.Tab, isRtl && styles.Rtl)}
        onClick={openModal}
      >
        <div className={styles.Inner}>
          <span className={styles.Title}>
            <T id="widget_reviews_tab_title" defaultMessage="Reviews" />
          </span>
          <span className={styles.Rating} />
        </div>
      </div>
    </>
  );
}
